export default __webpack_public_path__ + "static/media/2132.32150bb8.png";